var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEconomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}.cls-2{fill:none;stroke:#b7b7b7;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.15,10.3V9.59a2.83,2.83,0,0,1-1.32-.35l.22-.73a2.54,2.54,0,0,0,1.27.36c.5,0,.85-.22.85-.57s-.28-.52-.88-.71c-.85-.27-1.4-.63-1.4-1.34A1.34,1.34,0,0,1,7.18,5V4.26h.63v.68a2.61,2.61,0,0,1,1.12.27l-.22.7a2.35,2.35,0,0,0-1.12-.28c-.56,0-.74.27-.74.51s.3.47,1,.7c.89.3,1.3.68,1.3,1.38A1.41,1.41,0,0,1,7.78,9.55v.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 7.5,
    cy: 7.5,
    r: 5.57
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomy);
export default __webpack_public_path__ + "static/media/economy.0c193217dfa3024a4e69e5fce4fde275.svg";
export { ForwardRef as ReactComponent };